import '../../App.css';
import React, { useContext } from "react";
import { ApiContext } from "../../context/ApiContext";
import { Form, Row, Col } from 'react-bootstrap';
import { FaTimes } from 'react-icons/fa';
import { StyleContext } from '../../context/StyleContext';
import { ServicoContext } from '../../context/ServicoContext';

function ModalEditarDominioMapaCalor({ currentPage }) {
    const { EditarDominioMapaCalor, EdicaoDominioMapaCalor, setEdicaoDominioMapaCalor, setModalEditarDominioMapaCalor, setError } = useContext(ApiContext)
    const { Permissao } = useContext(ApiContext)
    const { btnVer, btnCriar } = useContext(StyleContext)

    const editar = (e) => {
        if (e) e.preventDefault();
        if (!EdicaoDominioMapaCalor.descricao) {
            setError("Descrição não informada");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        } else if (!EdicaoDominioMapaCalor.corHexadecimal) {
            setError("Cor não informada");
            setTimeout(() => {
                setError("");
            }, 3000);
            return;
        }
        EditarDominioMapaCalor(currentPage)
            .then(() => {
                setModalEditarDominioMapaCalor(false)
            })
            .catch((error) => {
                console.log(error)
            })
    }

    const handleChange = (event) => {
        setEdicaoDominioMapaCalor({ ...EdicaoDominioMapaCalor, [event.target.name]: event.target.value })
    }

    return (
        <div className="modal-novo">
            <div className="modal-novo-interno">
                <div className="header-modal">
                    <h1 className="h1-modal">Editar Domínio do Mapa de Calor</h1>
                    <div className="btn-close-modal" onClick={() => setModalEditarDominioMapaCalor(false)}>
                        <FaTimes />
                    </div>
                </div>
                <div>
                    <div className="modal-content">
                        <Row>
                            <Col xs={11}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control maxLength={255} defaultValue={EdicaoDominioMapaCalor?.descricao} onChange={handleChange} name="descricao" />
                                </Form.Group>
                            </Col>
                            <Col xs={1}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Cor</Form.Label>
                                    <Form.Control type='color' defaultValue={EdicaoDominioMapaCalor?.corHexadecimal} onChange={handleChange} name="corHexadecimal" />
                                </Form.Group>
                            </Col>
                        </Row>
                    </div>
                    <div className="footer-modal-criar-demanda">
                        <button type="button" className="btn-dash btn-ver" style={btnVer} onClick={() => setModalEditarDominioMapaCalor(false)}>Cancelar</button>
                        {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                            <button type='button' className="btn-dash btn-criar" style={btnCriar} onClick={(e) => {
                                e.preventDefault();
                                editar();
                            }}>Salvar</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ModalEditarDominioMapaCalor